import useEmailBaseActions from './useEmailBaseActions'
export default useEmailBaseActions
